import { extend } from "flarum/common/extend";
import CommentPost from "flarum/forum/components/CommentPost";
import Button from "flarum/components/Button";

export default function () {
  extend(CommentPost.prototype, "actionItems", function (items) {
    const post = this.attrs.post;
    const discussion = post.discussion();

    if (app.session.user) {
      const states = {
        none: {
          label: app.translator.trans(
            "flarum-subscriptions.forum.discussion_controls.follow_button"
          ),
          icon: "fas fa-star",
          save: "follow",
        },
        follow: {
          label: app.translator.trans(
            "flarum-subscriptions.forum.discussion_controls.unfollow_button"
          ),
          icon: "far fa-star",
          save: false,
        },
        ignore: {
          label: app.translator.trans(
            "flarum-subscriptions.forum.discussion_controls.unignore_button"
          ),
          icon: "fas fa-eye",
          save: false,
        },
      };

      const subscription = discussion.subscription() || "none";

      items.add(
        "subscription",
        Button.component(
          {
            icon: states[subscription].icon,
            onclick: discussion.save.bind(discussion, {
              subscription: states[subscription].save,
            }),
          },
          states[subscription].label
        )
      );
    }
  });
}
